<template>
<div>
  <div class="title-wrapper">
    <p class="title-text">{{title}}</p>

    <p :class="rightButton?'desc-l':'desc-r'" v-if="desc" @click="clickBtn">{{desc}}</p>
    <img src="@/assets/right-arrow-gray.png"
         alt=""
         class="right-arrow"
         v-if="rightArrow && !rightButton"/>
    <span class="right-button"
          @click="clickBtn"
          v-if="rightButton">{{rightButton}}</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'ModuleTitle',
  props: {
    title: {
      type: String,
      default: '模块标题',
    },
    rightArrow: {
      type: Boolean,
    },
    rightButton: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    rightButtonEvent: {
      type: Function,
      default: () => {
      },
    },
  },
  methods: {
    clickBtn() {
      console.log('sssssss');
      this.rightButtonEvent();
    },
  },
};
</script>

<style scoped lang="less">
  .title-wrapper {
    background-color: #ffffff;
    height: 90px;
    margin: 0px 0px;
    margin-top: 0px;
    margin-left: 24px;
    margin-right: 18px;
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .title-text {
    font-weight: bold;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
    text-align: left;
  }
.desc-l{
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #666666;
    line-height: normal;
    text-align: left;
    margin-left: 20px;
    flex: 1;
}
.desc-r{
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #666666;
    line-height: normal;
    text-align: right;
    margin-left: 30px;
    flex: 1;
}
  .right-arrow {
    width: 32px;
    height: 32px;
  }

  .right-button {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #008AFF;
    border-radius: 29px;
    padding: 0px 20px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #008AFF;
  }
</style>
